import React from "react";
import { connect } from "react-redux";
import { Button } from "semantic-ui-react";

import { selector } from "../";
import { DeleteDialog } from "../../components";
import { setDeleteGuestlistModal, updateGuestlist } from "../../redux/actionCreators/guestlist";
import { SettingsForm, TypeSettings } from "./index";

interface IPropsFromDispatch {
  saveGuestlist: (guestlist: server.dto.LegacyGuestlist) => any
  setShowDeletionModal: (isShown: boolean) => any
}

interface IPropsFromState {
  guestlist: server.dto.LegacyGuestlist
  deletionModalIsShown: boolean
}

interface IProps {
  onDelete: () => void
}

const mapStateToProps = (state): IPropsFromState => ({
  deletionModalIsShown: selector.isGuestlistDeletionModalShown(state),
  guestlist: selector.getGuestlist(state)
});

const mapDispatchToProps = (dispatch): IPropsFromDispatch => ({
  saveGuestlist: (guestlist: server.dto.LegacyGuestlist) => dispatch(updateGuestlist(guestlist)),
  setShowDeletionModal: (isShown: boolean) => dispatch(setDeleteGuestlistModal(isShown))
});

class GuestlistSettings extends React.Component<IPropsFromState & IPropsFromDispatch & IProps> {
  private readonly showDeletionModal = () => {
    this.props.setShowDeletionModal(true);
  };

  private readonly hideDeletionModal = () => {
    this.props.setShowDeletionModal(false);
  };

  public render(): JSX.Element {
    return (
      <>
        <div className="flex grow1 gap-larger" style={{ minHeight: 0 }}>
          <div className="grow1 flex-column gap" style={{ flexBasis: "49%" }}>
            <div className="grow1">
              <SettingsForm />
            </div>
            <div>
              <Button onClick={this.showDeletionModal} color="red">{RESX.Guestlist.DeleteGuestlist}</Button>
              <DeleteDialog
                isOpen={this.props.deletionModalIsShown}
                onDelete={async () => {
                  this.props.onDelete();
                  return Promise.resolve();
                }}
                handleClose={this.hideDeletionModal}
                message={RESX.GeneralWarnings.DeleteSure}></DeleteDialog>
            </div>
          </div>
          <div className="flex-column" style={{ flexBasis: "49%" }}>
            <div className="flex margin-bottom-large">
              <div className="grow1">
                <h2>{RESX.Guestlist.Lists}</h2>
              </div>
            </div>
            <div className="grow1 scrollbox-auto">
              <TypeSettings />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuestlistSettings);
